module.exports = {"ManagementDecisions":"Management Decisions"}